interface PageHeaderProps {
  eyebrow: string;
  title: string;
  subtitle?: string;
  right?: React.ReactNode;
}

export function PageHeader({
  eyebrow,
  title,
  subtitle,
  right,
}: PageHeaderProps): JSX.Element {
  return (
    <header className="mb-8 flex items-end justify-between gap-6 border-b border-ink-400 pb-5">
      <div>
        <div className="label-overline">{eyebrow}</div>
        <h1 className="mt-1 text-3xl font-semibold tracking-tight text-chrome-50">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-2 max-w-xl text-sm text-chrome-300">{subtitle}</p>
        )}
      </div>
      {right && <div className="flex shrink-0 items-center gap-3">{right}</div>}
    </header>
  );
}
